import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { EnumerationService } from 'src/app/modules/core/services/enumeration/enumeration.service';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-enumeration-cell',
    templateUrl: './enumeration-cell.component.html',
    styleUrls: ['./enumeration-cell.component.scss'],
    standalone: false
})
export class EnumerationCellComponent implements OnInit {
  value: any;

  constructor(
    private translate: TranslateService,
    private enumerationService: EnumerationService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);
    const selectedValues = !!params.data ? reader.getFieldValue(field.systemName) : params.value;
    this.value = '';

    selectedValues?.map(val => {
      const selectedItem = field.enumerationValues?.find(pv => pv.value === val);
      if (!!selectedItem) {
        this.value += this.value.length > 0 ? `, ${selectedItem.name}` : selectedItem.name;
      }
    });
    this.changeDetector.markForCheck();
  }
}
